import {
    Avatar,
    Badge,
    Button, ButtonGroup,
    Flex, IconButton, Menu, MenuButton, MenuItem, MenuList,
    Td,
    Text,
    Tr,
    useColorModeValue
} from "@chakra-ui/react";
import React from "react";
import {UserApproveModal} from "./UserApproveModal";
import {LuChevronDown} from "react-icons/lu";
import {ChevronDownIcon} from "@chakra-ui/icons";

function UserTableRow(props) {
    const {
        user,
        handleBlockUserModal,
        handleUserDetailModal,
        isApproveModalOpen,
        handleApproveModalClose,
        handleApproveConfirm,
        handleResetPasswordModal
    } = props;
    const textColor = useColorModeValue("gray.700", "white");
    const bgStatus = useColorModeValue("gray.400", "#1a202c");
    const colorStatus = useColorModeValue("white", "gray.400");
    const statusBg = user?.status === "Y" ? "green.400" : user?.status === "P" ? "yellow.400" : user?.status === "B" ? "red.400" : bgStatus;
    const statusLabel = user?.status === "Y" ? "Active" : user?.status === "B" ? "Blocked" : user?.status === "P" ? "Pending" : user?.status === "N" ? "In active" : "Inactive";

    return (
        <>
            <Tr>
                <Td minWidth={{sm: "250px"}} pl="0px">
                    <Flex align="center" py=".8rem" minWidth="100%" flexWrap="nowrap">
                        <Avatar src={user?.image} w="50px" borderRadius="12px" me="18px"/>
                        <Flex direction="column">
                            <Text
                                fontSize="md"
                                color={textColor}
                                fontWeight="bold"
                                minWidth="100%"
                            >
                                {user?.fullName}
                            </Text>
                            <Text fontSize="sm" color="gray.400" fontWeight="normal">
                                {user?.address}
                            </Text>
                            <Text fontSize="sm" color="gray.400" fontWeight="normal">
                                {user?.email} | {user?.mobileNumber}
                            </Text>
                        </Flex>
                    </Flex>
                </Td>

                <Td>
                    <Flex direction="column">
                        <Text fontSize="md" color={textColor} fontWeight="bold">
                            {user?.schoolName}
                        </Text>
                        {/*<Text fontSize="sm" color="gray.400" fontWeight="normal">*/}
                        {/*  {subdomain}*/}
                        {/*</Text>*/}
                    </Flex>
                </Td>

                <Td>
                    <Flex direction="column">
                        <Text fontSize="md" color={textColor} fontWeight="bold">
                            {user?.passwordAttempt}
                        </Text>
                    </Flex>
                </Td>

                <Td>
                    <Flex direction="column">
                        <Text fontSize="md" color={textColor} fontWeight="bold">
                            {user?.roleCode}
                        </Text>
                    </Flex>
                </Td>

                <Td>
                    <Badge
                        bg={statusBg}
                        color={colorStatus}
                        fontSize="16px"
                        p="3px 10px"
                        borderRadius="8px"
                    >
                        {statusLabel}
                    </Badge>
                </Td>

                <Td>
                    <ButtonGroup isAttached variant="outline">
                        <Button>Action</Button>
                        <Menu>
                            <MenuButton
                                as={IconButton}
                                icon={<ChevronDownIcon/>}
                                aria-label="Options"
                            />
                            <MenuList>
                                {user?.status === 'P' &&
                                    <MenuItem onClick={() => handleApproveConfirm(user)}>Approve</MenuItem>}
                                {user?.status === 'P' &&
                                    <MenuItem onClick={() => alert("Option 2 selected")}>Reject</MenuItem>}
                                {/*<MenuItem onClick={() => alert("Option 3 selected")}>Edit</MenuItem>*/}
                                <MenuItem
                                    onClick={() => handleBlockUserModal(user, true)}>{user?.status === "B" ? "Unblock" : "Block"}</MenuItem>
                                <MenuItem onClick={() => handleUserDetailModal(user, true)}>View</MenuItem>
                                <MenuItem onClick={() => handleResetPasswordModal(user, true)}>Reset Password</MenuItem>
                            </MenuList>
                        </Menu>
                    </ButtonGroup>
                </Td>
            </Tr>

            <UserApproveModal
                isApproveModalOpen={isApproveModalOpen}
                handleApproveModalClose={handleApproveModalClose}
                handleApproveConfirm={handleApproveConfirm}
                selectedUser={user}/>
        </>
    );
}

export default UserTableRow;
